import { programsSlice } from './programs.reducer';

export const {
  ADD_COLUMNS,
  REMOVE_COLUMN,
  SPLIT_COLUMN,
  FULL_COLUMN,
  PIN_COLUMN,
  ADD_PROGRAM,
  REMOVE_PROGRAM,
  UPDATE_PROGRAMS_SETTINGS,
  UPDATE_PROGRAMS,
} = programsSlice.actions;
